export default __webpack_public_path__ + "25d8cd3cdd3800487be28cdac5433ad3.png";